<template>
  <div>
    <div>
      <a-dropdown :trigger="['hover']" placement="bottomCenter">
        <div>
          <a-badge :count="userMsgCount+websiteMsgCount">
          
          <a-space size="small">
            <a-icon type="message" />
            </a-space>
            </a-badge>
        </div>
        <a-menu slot="overlay" class="menu-list">
          <a-menu-item>
            <router-link to="/WebsiteMsg">
              <div id="text-w">通知 <a-badge :count="websiteMsgCount" :offset="offset"/></div></router-link
            >
          </a-menu-item>
          <a-menu-item>
            <router-link to="/MsgList">
              <div id="text-w">私信 <a-badge :count="userMsgCount" :offset="offset"/></div></router-link
            >
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userMsgCount:0,
      websiteMsgCount:0,
      offset:[100,-10]
    };
  },

  created:function(){
     this.$req.get("/api/user/info", {}, (res) => {
      let url = "/api/message/user/select-by-receiver/"+res.data.id;
      this.$req.get(url,{},(res)=>{
        this.userMsgCount = res.data.length;
      })
      let url2 = "/api/message/website/select-by-receiver/"+res.data.id;
      this.$req.get(url2,{},(res)=>{
        this.websiteMsgCount = res.data.length;
      })
    });
  },
  computed: {
    currentUser: function () {
      return this.$store.state.user;
    },
  },
};
</script>

<style>
#text-w {
  color: rgba(0, 0, 0, 0.65);
}
</style>